export default "__VITE_ASSET__BPMPJ$mV__"